import { ReactElement, useCallback } from 'react';

import { useBoolean } from '@dreryk/react-common';

import { AccountAuthorizationModal } from './AccountAuthorizationModal';

type AccountAuthorizationModalRenderProps = {
   onAuthorization: () => Promise<unknown> | void;
};

type UseAccountAuthorizationModalReturnFn = {
   renderAccountAuthorizationnModal: (renderProps?: AccountAuthorizationModalRenderProps) => ReactElement | null;
   openAccountAuthorizationModal: VoidFunction;
};

export const useAccountAuthorizationModal = (): UseAccountAuthorizationModalReturnFn => {
   const [{ setTrue: openModal, setFalse: closeModal }, modalOpened] = useBoolean();

   return {
      openAccountAuthorizationModal: openModal,
      renderAccountAuthorizationnModal: useCallback(
         (renderProps) => {
            if (modalOpened) {
               return <AccountAuthorizationModal onAuthorization={renderProps?.onAuthorization} onClose={closeModal} />;
            }

            return null;
         },
         [closeModal, modalOpened]
      ),
   };
};
